import {$api} from "./index";


export const fetchAllTasks = async () => {
    const {data} = await $api.get('api/task')
    return data
}

export const fetchOneTask = async (id) => {
    const {data} = await $api.get('api/task/' + id)
    return data
}

export const updateTask = async (task) => {
    const {data} = await $api.put('api/task', task)
    return data
}

